import { Account } from '../models/Account';
import { host, getRequest, patchRequest, postRequest, deleteRequest } from './apiService';

export async function getAccounts() {
	return getRequest<Account[]>(`${host}/api/account`);
}

export async function updateAccount(id: string, account: Account) {
	return patchRequest<void>(
		`${host}/api/account/${id}`, account
	);
}

export async function addAccount(newAccount: Account) {
	const { id, ...objectWithoutId } = newAccount;
	return postRequest<Account | undefined>(
		`${host}/api/account`, objectWithoutId
	);
}

export async function deleteAccount(id: string) {
	return deleteRequest(`${host}/api/account/${id}`)
}